<template>
  <div>
    <location />
    <div class="latest-tourn-wrapper">
      <div class="overflow-hidden">
        <div class="image-wrapper">
          <!-- <img
            :src="
              tournamenttop.tournamentinfo &&
              tournamenttop.tournamentinfo.tourbinary &&
              tournamenttop.tournamentinfo.tourbinary[0] &&
              tournamenttop.tournamentinfo.tourbinary[0].filepath_web
                | get_img(
                          'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                        )
            "
          /> -->
          <div class="image-wrapper-inner"
          :class="{ 'is-active': setScale }"
            :style="{
                backgroundImage: `url(${
                    (tournamenttop.tournamentinfo &&
                    tournamenttop.tournamentinfo.tourbinary &&
                    tournamenttop.tournamentinfo.tourbinary[0] &&
                    tournamenttop.tournamentinfo.tourbinary[0].filepath_web)
                    ? $options.filters.get_img(tournamenttop.tournamentinfo.tourbinary[0].filepath_web)
                    : 'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                })`
            }">
        </div>
        </div>
        <router-link
          class="latest-tourn-info"
          v-if="tournamenttop.tournamentinfo"
          @mouseover.native="setScale = true"
          @mouseout.native="setScale = false"
          :to="{
            name: 'Condition',
            params: {
              id:
                tournamenttop.tournamentinfo &&
                tournamenttop.tournamentinfo.tournamentno,
              gametype_fk:
                tournamenttop.tournamentinfo &&
                tournamenttop.tournamentinfo.gametype_fk,
              participationtype_fk:
                tournamenttop.tournamentinfo &&
                tournamenttop.tournamentinfo.participationtype_fk,
            },
          }"
        >
          <div class="d-flex align-items-end justify-content-between latest-tourn-info-inner">
            <div>
              <p class="badge-group">
                <span class="badge tourn-type">
                  {{
                    tournament_type(
                      tournamenttop.tournamentinfo &&
                        tournamenttop.tournamentinfo.type
                    )
                  }}
                </span>
                <span class="badge tourn-game-type">
                  {{ game_type(tournamenttop.tournamentinfo &&
                    tournamenttop.tournamentinfo.gametype_fk)
                  }}
                </span>
              </p>
              <h2 class="tourn-title line-clamp-2">
                {{
                  tournamenttop.tournamentinfo && tournamenttop.tournamentinfo.title
                }}
              </h2>
              <p class="tourn-rank-type">
                <!-- {{ game_type(tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.gametype_fk)
                }}
                <strong>&middot;</strong>  -->
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.tour_rank_type | tour_rank_type
                }}
              </p>
              <!-- <p class="info">
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.description
                }}
              </p> -->
            </div>
            <div class="row row-cols-1 row-cols-sm-auto gy-1">
              <div
                class="col text-date"
                v-if="
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_private
                "
              >
                <!-- 사용자 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_private
                    | dateformat
                }}
                ~
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_enddate.timezone_private
                    | dateformat
                }}
              </div>
              <div
                class="col text-date"
                v-else-if="
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_common
                "
              >
                <!-- 서비스 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_common
                    | dateformat
                }}
                ~
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_enddate.timezone_common
                    | dateformat
                }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="page wrap-1200 mt-percent">
      <b-form
        @submit="onSubmit"
        class="filter-group row row-cols-2 row-cols-sm-4 row-cols-lg-6 g-2 justify-content-end"
        :style="{ marginTop: `calc(-8px + ${setHeight}px)` }"
      >
        <div class="col">
          <select v-model="searchData.pagesize">
            <option value="9" selected>
              {{ $t("filter.common.sort_by_9") }}
            </option>
            <option value="18">{{ $t("filter.common.sort_by_18") }}</option>
            <option value="27">{{ $t("filter.common.sort_by_27") }}</option>
          </select>
        </div>
        <div class="col">
          <select name="type" v-model="searchData.tourstatus_fk">
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("text.common.ready") }}</option>
            <option value="2">{{ $t("text.common.playing") }}</option>
            <option value="3">{{ $t("text.common.completed") }}</option>
          </select>
        </div>
        <div class="col">
          <select
            aria-label="Select one"
            name="searchtype"
            v-model="searchData.tourtype_fk"
          >
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("text.common.status_public") }}</option>
            <option value="2">
              {{ $t("text.common.status_invitational") }}
            </option>
            <!-- <option value="2">매장명</option> -->
            <!-- <option value="3">{{ $t("filter.common.course") }}</option> -->
          </select>
        </div>
        <div class="col">
          <select
            aria-label="Select one"
            name="searchtype"
            v-model="searchData.tour_rank_type"
          >
            <option value="-1">{{ $t("filter.common.total") }}</option>
            <option value="0">
              {{ $t("filter.common.low_gross") }} /
              {{ $t("filter.common.low_net") }}
            </option>
            <option value="1">{{ $t("filter.common.low_gross") }}</option>
            <option value="2">
              {{ $t("filter.common.low_net") }}
            </option>
            <!-- <option value="2">매장명</option> -->
            <!-- <option value="3">{{ $t("filter.common.course") }}</option> -->
          </select>
        </div>
        <div class="col-12 col-lg-4 flex-grow-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="searchname"
              v-model="searchData.searchname"
              :placeholder="
                $t('alert.common.field_enter', {
                  field: $t('title.common.tournament'),
                })
              "
            />
            <button
              class="btn btn-primary btn-md icon-search"
              type="submit"
            ></button>
          </div>
        </div>
      </b-form>

      <div
        v-if="total_cnt > 0"
        class="tourn-card row row-cols-1 row-cols-md-2 row-cols-lg-3 gx-xl-5 gy-5"
      >
        <div class="col" v-for="(item, index) in items" :key="'a' + index">
          <router-link
            v-if="item.tournamentinfo"
            :to="{
              name: 'Condition',
              params: {
                id: item.tournamentinfo && item.tournamentinfo.tournamentno,
                gametype_fk:
                  item.tournamentinfo && item.tournamentinfo.gametype_fk,
                participationtype_fk:
                  item.tournamentinfo &&
                  item.tournamentinfo.participationtype_fk,
              },
            }"
          >
            <div class="card">
              <div class="card-img-wrapper">
                <img
                  :src="
                    item.tournamentinfo &&
                    item.tournamentinfo.tourbinary &&
                    item.tournamentinfo.tourbinary[0] &&
                    item.tournamentinfo.tourbinary[0].filepath_web
                      | get_img(
                      'https://hojustorage.s3.ap-southeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                    )
                  "
                />
              </div>

              <div class="card-body">
                <p class="badge-group">
                  <span class="badge tourn-type">
                    {{ tournament_type(item.tournamentinfo.type) }}
                  </span>
                  <span class="badge tourn-game-type">
                    {{ game_type(item.tournamentinfo &&
                      item.tournamentinfo.gametype_fk)
                    }}
                  </span>
                </p>
                <h5 class="tourn-title">{{ item.tournamentinfo.title }}</h5>
                <p class="tourn-rank-type">
                  <!-- {{ game_type(item.tournamentinfo &&
                    item.tournamentinfo.gametype_fk)
                  }}
                  <strong>&middot;</strong> -->
                  {{ item.tournamentinfo.tour_rank_type | tour_rank_type }}
                </p>
              </div>

              <div class="card-footer">
                <p
                  class="text-truncate text-date"
                  v-if="
                    item.tournamentinfo.timezone_startdate &&
                    item.tournamentinfo.timezone_startdate.timezone_private
                  "
                >
                  <dfn
                    class="time-zone-mark badge rounded-pill bg-orange"
                    title="Connect time"
                    >CT</dfn
                  >
                  {{
                    item.tournamentinfo.timezone_startdate.timezone_private
                      | dateformat
                  }}
                  ~
                  {{
                    item.tournamentinfo.timezone_enddate.timezone_private
                      | dateformat
                  }}
                </p>

                <!-- 서비스 시간 -->
                <p
                  class="text-truncate text-date"
                  v-else-if="
                    item.tournamentinfo.timezone_startdate &&
                    item.tournamentinfo.timezone_startdate.timezone_common
                  "
                >
                  <dfn
                    class="time-zone-mark badge rounded-pill bg-green"
                    title="Standard time"
                    >ST</dfn
                  >
                  {{
                    item.tournamentinfo.timezone_startdate.timezone_common
                      | dateformat
                  }}
                  ~
                  {{
                    item.tournamentinfo.timezone_enddate.timezone_common
                      | dateformat
                  }}
                </p>
              </div>
            </div>
          </router-link>
          <b-button
            size="md"
            variant="primary w-100"
            :aria-label="$t('text.common.participation')"
            @click="participation(item.tournamentinfo.tournamentno)"
            v-if="
              item.tournamentinfo.gametype_fk == 1 &&
              item.tournamentinfo.participationtype_fk == 2
            "
          >
            {{ $t("text.common.participation") }}
          </b-button>
          <b-button
            size="md"
            variant="primary w-100 opacity-100"
            :aria-label="$t('text.common.offline')"
            disabled
            v-if="item.tournamentinfo.gametype_fk == 9"
          >
            {{ $t("text.common.offline") }}
          </b-button>
          <b-button
            size="md"
            variant="primary w-100 opacity-100"
            :aria-label="$t('text.common.free')"
            disabled
            v-if="
              item.tournamentinfo.gametype_fk == 1 &&
              item.tournamentinfo.participationtype_fk == 1
            "
          >
            {{ $t("text.common.free") }}
          </b-button>
        </div>
      </div>

      <div v-else>
        <table class="table board">
          <tbody>
            <tr>
              <td class="text-center">{{ $t("text.common.no_data") }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        aria-label="Page navigation"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <a v-if="active">{{ page }}</a>
          <a v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>
    </div>

    <b-toast
      id="toast-require-login"
      toaster="position-fixed top-50 start-50 translate-middle"
      no-close-button
      no-auto-hide
      solid
      body-class="p-4 text-center"
    >
      <div class="avatar avatar-lg mt-2 bg-orange border-0">
        <h3 class="material-icons text-white">person</h3>
      </div>
      <h6 class="sub-title mt-3 mb-2">{{ $t("text.common.require_login") }}</h6>
      <p class="pt-1">{{ $t("text.common.go_login_page") }}</p>
      <div class="btn-bottom-wrapper mt-3">
        <b-button
          size="sm"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvToast.hide('toast-require-login')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          :aria-label="$t('button.common.login')"
          @click="$router.push('/Login')"
        >
          {{ $t("button.common.login") }}
        </b-button>
      </div>
    </b-toast>

    <b-modal
      id="modal-entry-fee-payment"
      @shown="onModalShown"
      ref="modal-entry-fee-payment"
      size="md"
      centered
      scrollable
      no-close-on-backdrop
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h3>{{ $t("text.common.entry_fee_payment") }}</h3>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
        </b-button>
      </template>
      <template v-if="pay_flag == '1'">
        <p class="modal-subtitle lh-sm">
          {{ tournamentinfo.tourdefine.title }}
        </p>
        <b-form
          class="row row-cols-sm-auto g-2 justify-content-end"
        >
          <div class="row g-0 table-type header-col p-keep">
            <div class="col-sm-4">
              {{ $t("title.common.player") }}
            </div>
            <div class="col-sm-8">
              <p class="d-flex flex-wrap">
                <strong class="me-1">{{ $t("text.common.id") }}</strong>
                <span>: {{ tournamentinfo.player.player_id }}</span>
              </p>
              <p class="d-flex flex-wrap mt-1">
                <strong class="me-1">{{ $t("title.common.nickname") }}</strong>
                <span class="text-nickname"
                  >: {{ tournamentinfo.player.nickname }}</span
                >
              </p>
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.entry_limit") }}
            </div>
            <div class="col-sm-8 text-red">
              {{ tournamentinfo.tour_results.total_game || 0 }} /
              {{ tournamentinfo.tourdefine.entrylimit | transToValue("∞") }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.common.product_name") }}
            </div>
            <div class="col-sm-8">
              {{ product.name }}
            </div>

            <div class="col-sm-4">
              {{ $t("title.tournament.description") }}
            </div>
            <div class="col-sm-8">
              {{ product.description }}
            </div>
            <div class="col-sm-4">
              {{ $t("text.common.entry_fee") }}
            </div>

           <template v-if="coupon && coupon.id">
              <div class="col-sm-8">
                <span class="origin-price">
                  {{ product.amount | stripe_unit_amount(product.currency) }}
                </span>
                <span class="text-blue" v-if="coupon.percent_off">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.percent_off }}% off)
                </span>
                <span class="text-blue" v-if="coupon.discounted_amount">
                  {{ coupon.discounted_amount | stripe_unit_amount(product.currency) }}
                   ({{coupon.discounted_amount | stripe_unit_amount(product.currency) }} off)
                </span>                
<p class="text-red fw-500 lh-120 fs-12" v-if="coupon.discounted_amount < 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>
              </div>

            </template>
            <div class="col-sm-8" v-else>
              <p>{{ product.amount | stripe_unit_amount(product.currency) }}</p>
            </div>
            <template v-if="product && product.is_promotion">
              <div class="col-sm-4">
                {{ $t("title.common.coupon") }}
              </div>
              <div class="col-sm-8">
                <div class="input-group">
                    <input
                      type="text"
                      class="form-control "
                      :placeholder="$t('title.common.coupon_code')"
                      :aria-label="$t('title.common.coupon_code')"
                      autocomplete="off"
                      v-model="couponCode"
                    />
                    <button
                      class="btn btn-primary btn-md "
                      type="button"
                      id="id"
                      @click="coupon_check(tournamentinfo.tourdefine && tournamentinfo.tourdefine.tour_pk)"
                    >
                      {{ $t("button.common.apply") }}
                    </button>
                </div>
              </div>
            </template>
            <div class="col-sm-4">
              {{ $t("text.common.card_info") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <div class="col-12" id="card-number-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="1234 1234 1234 1234"
                    :aria-label="$t('text.common.card_number')"
                    name="CardNumber"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-expiry-element">
                  <!-- <input
                    type="text"
                    class="form-control"
                    placeholder="MM / YY"
                    :aria-label="$t('text.common.card_expiry')"
                    name="CardExpiry"
                    autocomplete="off"
                  /> -->
                </div>
                <div class="col-6" id="card-cvc-element"></div>
              </div>
            </div>

            <div class="col-sm-4">
              {{ $t("text.common.zip_code") }}
            </div>
            <div class="col-sm-8">
              <div class="row g-2">
                <!-- <div class="col-12">
                  <select name="countryno">
                    <option value="">{{ $t("title.common.choose") }}</option>
                  </select>
                </div> -->
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    :placeholder="$t('text.common.zip_code')"
                    :aria-label="$t('text.common.zip_code')"
                    name=""
                    autocomplete="off"
                    v-model="postalCode"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </template>
      <!-- 결제 정상 완료 -->
      <template v-if="pay_flag == '2'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-success">check_circle</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_complete") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_successfully") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_method") }}
              </div>
              <div class="col-sm-8">
                {{
                  (pay_result.paymentIntent.payment_method_types &&
                    pay_result.paymentIntent.payment_method_types.join(", ")) ||
                  ""
                }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment_amount") }}
              </div>
              <div class="col-sm-8">
                {{
                  pay_result.paymentIntent.amount
                    | stripe_unit_amount(pay_result.paymentIntent.currency)
                }}
                <p class="text-red fw-500 lh-120 fs-12" v-if="pay_result.paymentIntent.amount <= 50">
                   Please note: A minimum payment of $0.50 AUD is required even if your total is $0 (after discounts or coupons).
                </p>
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.payment") }} {{ $t("text.common.number") }}
              </div>
              <div class="col-sm-8">{{ pay_result.paymentIntent.id }}</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.date") }}
              </div>
              <div class="col-sm-8 text-date">
                {{ (pay_result.paymentIntent.created * 1000) | dateformat }}
              </div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.company") }}
              </div>
              <div class="col-sm-8">XGAU</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 참가 제한 초과 -->
      <template v-if="pay_flag == '3'">
        <div class="my-5 text-center">
          <p class="material-icons fs-48 text-orange">report</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ pay_fail_message }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.participate_another_tourn") }}
          </p>
        </div>
      </template>
      <!-- 결제 실패 -->
      <template v-if="pay_flag == '4'">
        <div class="mt-5 mb-4 text-center">
          <p class="material-icons fs-48 text-danger">dangerous</p>
          <h6 class="sub-title my-2 pt-1 text-capitalize">
            {{ $t("text.common.payment_failed") }}
          </h6>
          <p class="pt-1 fs-14 lh-sm">
            {{ $t("text.common.payment_unsuccessful") }}<br />
            {{ $t("text.common.please_try_again") }}
          </p>
        </div>

        <div class="card">
          <div class="card-body px-3 py-2 fs-14">
            <div class="row g-0 table-type header-col p-keep border-0">
              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.code") }}
              </div>
              <div class="col-sm-8">404</div>

              <div class="col-sm-4 bg-transparent">
                {{ $t("text.common.error") }} {{ $t("text.common.reason") }}
              </div>
              <div class="col-sm-8">Card Company Failure</div>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button> -->

        <!-- <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.confirm')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.confirm") }}
        </b-button> -->

        <b-button
          size="md"
          v-if="pay_flag == '1'"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>

        <b-button
          size="md"
          v-else-if="pay_flag == '2'"
          variant="outline-secondary"
          :aria-label="$t('button.common.done')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.done") }}
        </b-button>

        <b-button
          size="md"
          v-else
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-entry-fee-payment')"
        >
          {{ $t("button.common.close") }}
        </b-button>

        <b-button
          v-if="pay_flag == '1'"
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.submit')"
          type="button"
          @click="onPaySubmit"
        >
          {{ $t("button.common.submit") }}
        </b-button>

        <!-- <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.try_again')"
        >
          {{ $t("button.common.try_again") }}
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/tournament";
import { myMixin } from "@/mixin/myMixin";
import { loadStripe } from "@stripe/stripe-js";

export default {
  name: "TournamentSchedule",
  components: {
    location,
  },
  data() {
    return {
      setScale: false,
      setHeight: 0,
      searchData: {
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        tourstatus_fk:
          this.$route.query.tourstatus_fk ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tourstatus_fk) ||
          0,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        tourtype_fk:
          this.$route.query.tourtype_fk ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tourtype_fk) ||
          0,
        tourstatus_fk:
          this.$route.query.tourstatus_fk ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tourstatus_fk) ||
          0,
        tour_rank_type:
          this.$route.query.tour_rank_type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tour_rank_type) ||
          -1,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          9,
      },
      page_total: 1,
      total_cnt: 0,
      login: sessionStorage.getItem("token") ? true : false,
      items: [],
      tournamenttop: {},
      view_hide: null,

      tour_pk: null,
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      postalCode: "",
      couponCode: "",
      product: {},
      coupon: {},
      pay_result: { paymentIntent: {} },

      _stripe: {},
      pay_flag: 1,
      pay_fail_message: "",
      tournamentinfo: {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [],
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateHeight)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateHeight)
  },
  methods: {
    updateHeight() {
      this.$nextTick(() => {
        const el = this.$el.querySelector('.latest-tourn-info')
        if (el) {
          this.setHeight = el.clientHeight / 2
        }
      })
    },
    async onModalShown() {
      // 모달이 열리고 나서 mount 실행
      if (!this.stripe) {
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
      }
      process.env.VUE_APP_INSTAR_ACCESS_TOKEN;
      this.elements = this.stripe.elements();

      this.cardNumber = this.elements.create("cardNumber");
      this.cardNumber.mount("#card-number-element");

      this.cardExpiry = this.elements.create("cardExpiry");
      this.cardExpiry.mount("#card-expiry-element");

      this.cardCvc = this.elements.create("cardCvc");
      this.cardCvc.mount("#card-cvc-element");
    },

    participation(tour_pk) {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }

      this.tour_pk = null;
      this._stripe = {};
      this.stripe = null;
      this.elements = null;

      // 2. 카드 입력 필드 관련 초기화
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      this.postalCode = "";

      // 3. 쿠폰 및 상품 정보 초기화
      this.couponCode = "";
      this.coupon = {};
      this.product = {};

      // 4. 결제 결과 및 플래그 초기화
      this.pay_result = { paymentIntent: {} };
      this.pay_flag = 1;
      this.pay_fail_message = "";

      // 5. 대회 및 사용자 관련 복합 객체 초기화
      this.tournamentinfo = {
        player: {},
        tour_results: {},
        tourdefine: {},
        tour_order_list: [], // 배열은 빈 배열로
      };

      this.post_stripeinit(tour_pk);
    },

    participation_no() {
      alert(this.$i18n.t("alert.common.offline"));
      return false;
    },

    post_stripeinit(tour_pk) {
      ax.post_stripeinit(tour_pk, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;
          this.pay_flag = 1;
          this.$bvModal.show("modal-entry-fee-payment");
        } else {
          this.pay_flag = 3;
          this.pay_fail_message = data.message || "";

          this.$bvModal.show("modal-entry-fee-payment");
        }
      });
    },
    async onPaySubmit(event) {
      event.preventDefault();

      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardNumber,
        billing_details: { address: { postal_code: this.postalCode } },
      });

      if (error) return alert(error.message);

      ax.post_stripe_confirm(
        this.tour_pk,
        { product_id: this.product.id, paymentmethod_id: paymentMethod.id, coupon_code: this.couponCode },
        async (flag, data) => {
          this._stripe = data.stripe;
          // console.log("this.product", this.product);

          if (flag) {
            this.pay_result = await this.stripe.confirmCardPayment(
              this._stripe.client_secret
            );
            console.log("this.paymentIntent", this.pay_result);
            if (this.pay_result.error) {
              alert(this.pay_result.error.message);
            } else if (this.pay_result.paymentIntent.status === "succeeded") {
              const charges = this.pay_result.paymentIntent.charges
                ? this.pay_result.paymentIntent.charges.payment_method_details
                    .card
                : "";
              ax.post_order_insert(
                this.tour_pk,
                {
                  charges: JSON.stringify(charges),
                  payment_intent_id: this.pay_result.paymentIntent.id,

                  product: JSON.stringify({
                    amount: this.product.amount,
                    actual_amount: this.pay_result.paymentIntent.amount,
                    id: this.product.id,
                    name: this.product.name,
                    price_id: this.product.price_id,
                    currency: this.product.currency,
                    coupon_code: this.couponCode,

                  }),
                },
                (flag, data) => {
                  // console.log(flag, data);

                  if (flag) {
                    this.pay_flag = 2;
                  } else {
                    this.pay_flag = 3;
                    this.pay_fail_message = data.message || "";
                    // alert(data.message);
                  }
                }
              );
            }
          } else {
            alert(data.message);
          }
        }
      );

    },
//     async onPaySubmit(event) {
      //   event.preventDefault();

      //   // 1. 카드 정보로 PaymentMethod 생성
      //   const { paymentMethod, error } = await this.stripe.createPaymentMethod({
      //     type: "card",
      //     card: this.cardNumber,
      //     billing_details: { address: { postal_code: this.postalCode } },
      //   });

      //   if (error) return alert(error.message);

      //   // 2. 서버에 결제 시도 요청 (쿠폰 적용 포함)
      //   ax.post_stripe_confirm(
      //     this.tour_pk,
      //     {
      //       product_id: this.product.id,
      //       paymentmethod_id: paymentMethod.id,
      //       coupon_code: this.couponCode
      //     },
      //     async (flag, data) => {
      //       if (!flag) return alert(data.message);

      //       // 서버에서 전달받은 정보 (client_secret, mode 등)
      //       this._stripe = data.stripe;
      //       const mode = this._stripe.mode; // 'payment' 또는 'setup'
      //       let stripeResult;

      //       try {
      //         // 3. [핵심 분기] 금액에 따라 결제 또는 카드 등록 진행
      //         if (mode === 'setup') {
      //           // 0원 또는 최소 금액 미만일 때
      //           stripeResult = await this.stripe.confirmCardSetup(this._stripe.client_secret);
      //         } else {
      //           // 정상 결제 금액일 때
      //           stripeResult = await this.stripe.confirmCardPayment(this._stripe.client_secret);
      //         }

      //         console.log("Stripe Result:", stripeResult);

      //         if (stripeResult.error) {
      //           return alert(stripeResult.error.message);
      //         }

      //         // 4. 결과 객체 추출 (mode에 따라 접근 경로가 다름)
      //         const intent = (mode === 'setup') ? stripeResult.setupIntent : stripeResult.paymentIntent;

      //         if (intent.status === "succeeded") {
      //           // 결제 상세 정보 (PaymentIntent일 때만 존재)
      //           const charges = (mode === 'payment' && intent.charges)
      //             ? intent.charges.payment_method_details.card
      //             : "";

      //           // 5. 서버에 최종 주문 생성 요청
      //           ax.post_order_insert(
      //             this.tour_pk,
      //             {
      //               charges: JSON.stringify(charges),
      //               payment_intent_id: intent.id, // pi_... 또는 si_...
      //               product: JSON.stringify({
      //                 amount: this.product.amount,
      //                 actual_amount: (mode === 'payment') ? intent.amount : 0,
      //                 id: this.product.id,
      //                 name: this.product.name,
      //                 price_id: this.product.price_id,
      //                 currency: this.product.currency,
      //                 coupon_code: this.couponCode,
      //               }),
      //             },
      //             (flag, data) => {
      //               if (flag) {
      //                 this.pay_flag = 2; // 결제 성공 UI로 변경
      //               } else {
      //                 this.pay_flag = 3; // 실패 UI
      //                 this.pay_fail_message = data.message || "주문 생성 실패";
      //               }
      //             }
      //           );
      //         }
      //       } catch (e) {
      //         console.error("Payment Confirmation Error:", e);
      //         alert("처리 중 오류가 발생했습니다.");
      //       }
      //     }
      //   );
      // },
    get_tournamentlist() {
      this.view_hide = null;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_tournamentlist(this.searchData, (flag, data) => {
        this.total_cnt = data.tournamentlistcnt;
        this.page_total = Math.ceil(
          data.tournamentlistcnt / this.searchData.pagesize
        );
        this.items = data.tournamentlist;
        this.tournamenttop = data.tournamenttop;
        if (flag) {
        } else {
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          query: {
            searchname: this.searchData.searchname,
            searchtype: this.searchData.searchtype,
          },
        })
        .catch(() => {});
    },
    coupon_check(tour_pk) {

      if (this.couponCode === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.coupon"),
          })
        );
        return false;
      }

      ax.post_stripe_coupon(tour_pk, { couponCode: this.couponCode }, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;
          this.coupon = data.coupon;
          console.log('data.product', data.product);
          // this.pay_flag = 1;
          // this.$bvModal.show("modal-entry-fee-payment");
        } else {
          alert(data.message);
          this.couponCode = "";
          // this.pay_flag = 3;
          // this.pay_fail_message = data.message || "";

          // this.$bvModal.show("modal-entry-fee-payment");
        }
      });

    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },

  created() {
    this.get_tournamentlist();
  },
  watch: {
    "searchData.tourtype_fk": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.tourstatus_fk": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.tour_rank_type": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },

    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },

    "searchData.pageno": function () {
      this.get_tournamentlist();
    },
    'tournamenttop.tournamentinfo'(val) {
      if (val) {
        this.updateHeight()
      }
    }
  },
  mixins: [myMixin],
};
</script>
<style lang="scss" scoped>
#card-number-element,
#card-expiry-element,
#card-cvc-element {
  border: 1px solid #cdcfd1;
  padding: 10px 10px;
  background-color: #fff;
  height: 40px;
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#card-expiry-element,
#card-cvc-element {
  width: 49%;
}

#card-cvc-element {
  margin-left: 5px;
}
</style>
